// @flow

import ForecastMetric from "./ForecastMetric"
import ForecastMetricAlternate from "./ForecastMetricAlternate"
import ForecastMetricTitleGroup from "./ForecastMetricTitleGroup"
import MetricLabel from "./MetricLabel"

export { ForecastMetricAlternate, ForecastMetricTitleGroup, MetricLabel }

export default ForecastMetric



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/index.js